import React, {Component} from 'react';

import defaultMarker from './images/marker-icon.svg';
import geoLocationMarker from './images/geo-location-marker.svg';

import { ErrorBannerProvider, ErrorBanner } from "ErrorBanner"
import IsochroneMapLayer from 'IsochroneMapLayer';
import RoutesMapLayer from 'RoutesMapLayer';
import LanguageSelection from 'LanguageSelection';
import Footer from 'Footer';
import OnBoarding from 'OnBoarding';
import { GeocodingOptions, Geocoding } from 'Geocoding';
import { Map, Marker } from 'Map';
import MapActionBar from 'MapActionBar';
import Scenarios from 'Scenarios';
import SlidingMenu from 'SlidingMenu';
import { TranslationContext } from 'giro-react-toolkit/source/Translation';

import './App.scss';
import 'giro-react-toolkit/source/styles/global.scss';
import './styles/Global.scss';

/**
 * Main app component
 */
class App extends Component {
   constructor(props) {
      super(props);

      this.state = {
         markerPopupText: "",
         panelParameters: {
            selectedLocation: {
               placeName: reachMap.locationOptions ? reachMap.locationOptions.defaultPlaceName : "",
               latitude: reachMap.locationOptions ? reachMap.locationOptions.defaultLatitude : null,
               longitude: reachMap.locationOptions ? reachMap.locationOptions.defaultLongitude : null
            },
            selectedConcept: reachMap.concept.defaultScenario,
            selectedDay: reachMap.daysOptions.defaultValue,
            selectedTime: reachMap.defaultTime,
            selectedDur: reachMap.durationOptions.defaultValue
         },
         isochrone: {
            selectedLocation: {
               latitude: reachMap.locationOptions ? reachMap.locationOptions.defaultLatitude : null,
               longitude: reachMap.locationOptions ? reachMap.locationOptions.defaultLongitude : null
            },
            selectedConcept: reachMap.concept.defaultScenario,
            selectedDay: reachMap.daysOptions.defaultValue,
            selectedTime: reachMap.defaultTime,
            selectedDur: reachMap.durationOptions.defaultValue
         },
         currentLocation: null,
         showSlidingMenu: false,
         showOnBoarding: !localStorage.getItem('firstVisitDone')
      };

      // utilisé pour le geocoding, permet d'annuler un appel pour éviter d'avoir les
      // retours multiple dans le désordre et de ne pas afficher la bonne information
      this.geocodeAbortController = null;

      this.map = React.createRef();

      this.onLayoutChanged = this.onLayoutChanged.bind(this);
      this.onClearLocation = this.onClearLocation.bind(this);
      this.onConceptChange = this.onConceptChange.bind(this);
      this.onDragEnd = this.onDragEnd.bind(this);
      this.onSelectedDay = this.onSelectedDay.bind(this);
      this.onSelectedLocation = this.onSelectedLocation.bind(this);
      this.onSelectedDur = this.onSelectedDur.bind(this);
      this.onSelectedTime = this.onSelectedTime.bind(this);
      this.onIsochroneFetchCompleted = this.onIsochroneFetchCompleted.bind(this);
      this.updateIsochroneState = this.updateIsochroneState.bind(this);
      this.isIsochroneStateUptoDate = this.isIsochroneStateUptoDate.bind(this);
   }

   /**
    * Builds the isochrone state from the component state panel parameters.
    * The isochrone state currently includes all the panel parameters.
    * If it is no longer the case, this method should be updated.
    */
   updateIsochroneState() {
      this.setState((state) => {
         return { isochrone: state.panelParameters };
      });
   }

   /**
    * Checks if the isochrone state is up to date compared to the component state panel parameters.
    * @returns True if the isochrone state is up to date.
    */
   isIsochroneStateUptoDate() {
      let uptoDate =
         (this.state.isochrone.selectedLocation.latitude === this.state.panelParameters.selectedLocation.latitude &&
            this.state.isochrone.selectedLocation.longitude === this.state.panelParameters.selectedLocation.longitude &&
            this.state.isochrone.selectedConcept === this.state.panelParameters.selectedConcept &&
            this.state.isochrone.selectedDay === this.state.panelParameters.selectedDay &&
            this.state.isochrone.selectedTime === this.state.panelParameters.selectedTime &&
            this.state.isochrone.selectedDur === this.state.panelParameters.selectedDur);
      return (uptoDate);
   }

   componentDidMount() {
                             // On initialise le texte du marker ici car
                             // this.context n’est pas initialisé dans le constructeur
      this.setState({ markerPopupText: this.context.localizeValue('ReachMapRes.MarkerPopupText') });

                             // forcer le recalcul de la taille de la carte, sinon sur FF il peut manquer des tuiles
                             // et le popup peut être au mauvais endroit.
      this.onLayoutChanged();
   }

   /**
    * Return the offset for the center of the map. Useful when the map is partially hidden
    * by the option panel.
    */
   centerOffset() {
      if (window.innerWidth < 800) {
         // En mode small device, retirer la hauteur du panneau d'option du calcul de hauteur
         var panelEl = document.getElementById("option-panel");
         if (panelEl) {
            return (panelEl.clientHeight);
         }
      }
      return (0);
   }

   /**
    * Handle the click event on a suggestion from the autocomplete component.
    * @param {GeocodingResult} selectedLocation - the location item that was clicked
    */
   onSelectedLocation(selectedLocation) {
      const newSelectedLocation = {
         placeName: selectedLocation.placeName,
         latitude: selectedLocation.latitude,
         longitude: selectedLocation.longitude
      }

      this.setState((state) => {
         return { panelParameters: { ...state.panelParameters, selectedLocation: newSelectedLocation },
            markerPopupText: null };
      });
   }
   /**
    * Handle the clear location event.
    * Sets the latitude and longitude to null in order to delete the marker on the map.
    */
   onClearLocation() {
      this.setState((state) => {
         return { panelParameters: { ...state.panelParameters, selectedLocation: { placeName: "", latitude: null, longitude: null }}};
      });
   }
   /**
    * Handle the concept change event
    * @param selectedConcept The selected concept
    */
   onConceptChange(selectedConcept) {
                             // Update the isochrone state to provoke an automatic refresh
      this.setState((prevState) => {
         let newParams = { ...prevState.panelParameters };
         newParams.selectedConcept = selectedConcept;
         return { isochrone: newParams, panelParameters: newParams };
      });
   }
   /**
    * A function to execute when the user stops dragging the marker on the map.
    * @param {object} position of the geographical point object containig the latitude and longitude.
    */
   onDragEnd(position) {
                              // Cancel the in progress reverse geocoding request and make a new one.
      if (this.geocodeAbortController)
         this.geocodeAbortController.abort();

      var latitude = position.lat;
      var longitude = position.lng;

      if (window.AbortController)
         this.geocodeAbortController = new AbortController();

      this.geocodingReverseRequest = new Geocoding().reverse(new GeocodingOptions({ latitude, longitude }, true /*reverseGecoding*/),
         this.geocodeAbortController,
         (results) => {
            var placeName = (results && results.length) ? results[0].placeName : `${latitude},${longitude}`;
                             // Update the isochrone state to provoke an automatic refresh
            this.setState((prevState) => {
               let newParams = { ...prevState.panelParameters };
               newParams.selectedLocation = { placeName: placeName, latitude: latitude, longitude: longitude };
               return { isochrone: newParams, panelParameters: newParams};
            });
         });
   }
   /**
    * Handle the day picker change event
    * @param selectedDay The selected day
    */
   onSelectedDay(selectedDay) {
      this.setState((state) => {
         return { panelParameters: { ...state.panelParameters, selectedDay }};
      });
   }

   /**
    * Handle the day picker change event
    * @param selectedDay The selected day
    */
   onSelectedTime(selectedTime) {
      this.setState((state) => {
         return { panelParameters: { ...state.panelParameters, selectedTime }};
      });
   }

   /**
    * Handle the isochrone total duration change event
    * @param selectedDur The selected duration
    */
   onSelectedDur(selectedDur) {
      this.setState((state) => {
         return { panelParameters: { ...state.panelParameters, selectedDur }};
      });
   }

   /**
    * Handles layout change
    */
   onLayoutChanged() {
      this.map.current && this.map.current.invalidateSize();
   }

   /**
    * Handles the completion of the isochrone fetching
    * @param hasImage  The isochrone has an image
    * @param firstLoad  indicates if the fetch is from the initial load of the application
    */
   onIsochroneFetchCompleted(hasImage, firstLoad) {
      if (!this.context)
         return;

      if (!hasImage) {
         this.setState({ markerPopupText: this.context.localizeValue('ReachMapRes.NoStopText') });
      } else if (!firstLoad) {
         // do not hide move marker text on load
         this.setState({ markerPopupText: null });
      }
   }

   /**
    * Open/Close sliding menu
    */
   openMenu(open) {
      this.setState({ showSlidingMenu: open });
   }

   /**
    * Open/close on boarding
    */
   showOnBoarding(show) {
      if (!show && !localStorage.getItem('firstVisitDone'))
         localStorage.setItem('firstVisitDone', true);
      this.setState({ showOnBoarding: show, showSlidingMenu: false });
   }

   /**
    * Render the component.
    */
   render() {
      let latitude = this.state.panelParameters.selectedLocation.latitude;
      let longitude = this.state.panelParameters.selectedLocation.longitude;

      return (
         <ErrorBannerProvider>
            <ErrorBanner />
            <SlidingMenu
               onAbout={() => {
                  this.showOnBoarding(true)
               }}
               onClose={() => {
                  this.openMenu(false)
               }}
               show={this.state.showSlidingMenu} />
            <main>
               <div className="application">
                  <OnBoarding
                     show={this.state.showOnBoarding}
                     onClose={() => {
                        this.showOnBoarding(false)
                     }} />
                  <LanguageSelection className="application__language-bar"/>
                  <Scenarios
                     className="application__pane"
                     { ...this.state.panelParameters }
                     onClearLocation={ this.onClearLocation }
                     onLayoutChanged={ this.onLayoutChanged }
                     onMenuClick={() => {
                        this.openMenu(true)
                     }}
                     onSelectedLocation={ this.onSelectedLocation }
                     onSelectedDay={ this.onSelectedDay }
                     onSelectedDur={ this.onSelectedDur }
                     onSelectedTime={ this.onSelectedTime }
                     isInMap={(el) => {
                        return (this.map.current.mapContainer.contains(el));
                     }} />
                  <Map
                     accessToken={reachMap.mapOptions.accessToken}
                     attribution={reachMap.mapOptions.attribution}
                     center={reachMap.mapOptions.center}
                     tileServerURL={reachMap.mapOptions.tileServerURL}
                     tileSize={reachMap.mapOptions.tileSize}
                     zoomOffset={reachMap.mapOptions.zoomOffset}
                     minZoom={reachMap.mapOptions.minZoom}
                     maxZoom={reachMap.mapOptions.maxZoom}
                     maxBounds={reachMap.mapOptions.mapBounds && reachMap.mapOptions.mapBounds.length == 2 ? [
                        [reachMap.mapOptions.mapBounds[0].latitude, reachMap.mapOptions.mapBounds[0].longitude],
                        [reachMap.mapOptions.mapBounds[1].latitude, reachMap.mapOptions.mapBounds[1].longitude]
                     ] : null}
                     onLongPress={this.onDragEnd}
                     zoom={reachMap.mapOptions.zoom}
                     className="application__map"
                     ref={this.map}>
                     <RoutesMapLayer
                        day={this.state.panelParameters.selectedDay}
                        concept={this.state.panelParameters.selectedConcept}
                        strokeWidth={reachMap.networkOptions.defaultWidth}
                        opacity={reachMap.networkOptions.defaultOpacity}
                        zoomOptions={reachMap.networkOptions.zoomOptions}
                        color={reachMap.mapOptions.networkColor}/>
                     <IsochroneMapLayer
                        latitude= {this.state.isochrone.selectedLocation.latitude}
                        longitude= {this.state.isochrone.selectedLocation.longitude}
                        day= {this.state.isochrone.selectedDay}
                        time={this.state.isochrone.selectedTime}
                        duration={this.state.isochrone.selectedDur}
                        concept={this.state.isochrone.selectedConcept}
                        showRefreshButton={ !this.isIsochroneStateUptoDate() }
                        onRefreshButtonClick={() => {
                           this.updateIsochroneState()
                        }}
                        onFetchCompleted={(hasImage, firstLoad) => this.onIsochroneFetchCompleted(hasImage, firstLoad) }/>
                     { /* current location marker */
                        this.state.currentLocation &&
                        <Marker
                           latitude={this.state.currentLocation.latitude}
                           longitude={this.state.currentLocation.longitude}
                           iconUrl={geoLocationMarker}
                           iconAnchor={[16, 16]}/>}
                     <Marker
                        latitude= {latitude}
                        longitude= {longitude}
                        iconUrl={defaultMarker}
                        iconAnchor= {reachMap.mapOptions.marker.iconAnchor}
                        draggable={true}
                        onDragEnd={this.onDragEnd}
                        popupText={this.state.markerPopupText}
                        onClosePopup={() => {
                           this.setState({ markerPopupText: null })
                        }}
                        centerOffset={(p) => this.centerOffset(p)} />
                     <MapActionBar
                        showOnBoarding={() => this.showOnBoarding(true) }
                        onGeoLocationSuccess={(position) => this.setState({ currentLocation: position.coords }) }/>
                  </Map>
                  <Footer
                     className="application__footer"
                     selectedConcept={this.state.panelParameters.selectedConcept}
                     onSelectedConcept={this.onConceptChange}
                     isochroneParam={this.state.isochrone} />
               </div>
            </main>
         </ErrorBannerProvider>
      );
   }
}

App.contextType = TranslationContext;

export default App;
